import { render, staticRenderFns } from "./micoapp_create.vue?vue&type=template&id=12a692d9&scoped=true"
import script from "./micoapp_create.vue?vue&type=script&lang=js"
export * from "./micoapp_create.vue?vue&type=script&lang=js"
import style0 from "./micoapp_create.vue?vue&type=style&index=0&id=12a692d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a692d9",
  null
  
)

export default component.exports